



















































import Vue from 'vue'
import CheckoutService from '@/services/CheckoutService'
import UpsellOffer, { UpsellOfferType } from '@/models/UpsellOffer'
import PaymentModal from '@/components/checkout/PaymentModal.vue'
import Offer, { OfferType, CheckoutSourceType } from '@/models/Offer'
import Product from '@/models/Product'
import Loader from '@/components/common/Loader.vue'
import ClassicUpsellTheme from '@/components/checkout/upsell/ClassicUpsellTheme.vue'
import NovaUpsellTheme from '@/components/checkout/upsell/NovaUpsellTheme.vue'
import { currency } from '@/helper/constants'
import { getContactId } from '../services'
import axios from 'axios'
import config from '@/config/index'
import http from './../../http-common'

export default Vue.extend({
  components: { ClassicUpsellTheme, NovaUpsellTheme, PaymentModal, Loader },
  async mounted() {
    this.builder = this.$route.query.builder
    this.preview = this.$route.query.preview
    this.contact = this.$store.state.contact
    this.checkoutPayload = this.$store.state.checkoutPayload
    this.featureFlag = this.$store.state.featureFlag
    await this.fetchUpsell()
    if(!this.adminMode) {
      await this.fetchContact()
    }
  },
  metaInfo() {
    const meta = {}

    if (this.styles) {
      meta['style'] = [
        {
          cssText: this.styles,
          type: 'text/css',
          vmid: 'offer-upsell-css'
        }
      ]
    }

    if (this.fontsToLoad) {
      meta['link'] = [
        {
          vmid: 'upsell-fonts',
          rel: 'stylesheet',
          href: this.fontsToLoad
        }
      ]
    }

    meta['script'] = [
      {
        src: 'https://js.stripe.com/v3/',
        async: true,
        type: 'text/javascript'
      }
    ]

    return meta
  },
  data() {
    currency
    OfferType
    return {
      currency,
      loading: false,
      upsellOffer: {} as UpsellOffer,
      offer: {} as Offer,
      products: [] as Array<Product>,
      OfferType,
      location: {},
      builder: '',
      preview: '',
      upsellSettings: {},
      checkoutPayload: {},
      optin: true,
      contact: {} as { [key: string]: any },
      showThankYouMsg: false,
      selectedTheme: 'Classic',
      errMsg: '',
      cToken: '',
      styles: '',
      fontsToLoad: '',
      offerAlreadyPurchased: false,
      url: '',
      showModal: false,
      disableCheckoutBtn: false,
      featureFlag: {},
      paymentMethods: []
    }
  },
  computed: {
    upsellId(): string {
      return this.$route.params.id
    },
    disableActions(): object {
      return {
        pointerEvents: this.builder || this.preview ? 'none' : 'all'
      }
    },
    adminMode(): boolean {
      return this.builder || this.preview
    },
    showCheckoutForm(): boolean {
      return !this.showThankYouMsg && !this.offerAlreadyPurchased
    },
    showPaymentForm(): boolean {
      return (
        !this.optin &&
        !this.showThankYouMsg &&
        !this.freeProduct &&
        !this.offerAlreadyPurchased
      )
    },
    freeProduct(): boolean {
      return this.offer.type === OfferType.free
    },
    libraryPath(): string {
      const featureFlag: any = this.featureFlag
      return featureFlag?.libraryV2 ? 'library-v2' : 'library'
    },
    checkoutSourceType(): string {
      return this.upsellOffer.upsellType === UpsellOfferType.INAPP
        ? CheckoutSourceType.INAPP
        : CheckoutSourceType.ONECLICK
    }
  },
  methods: {
    orderConfirmation({
      ct,
      previewUrl,
      upsellOfferId,
      featureFlag,
      closeModal
    }) {
      this.showThankYouMsg = true
      this.cToken = ct
      this.url = previewUrl
      this.featureFlag = featureFlag
      if (closeModal) {
        setTimeout(() => {
          window.close()
        }, 5000)
      }
    },
    async fetchContact() {
      let contactId = this.contact.id
      if (this.upsellOffer.upsellType === UpsellOfferType.INAPP) {
        contactId = getContactId()
        await axios
          .get(config.mainServerUrl + `/contact/membership/${contactId}`)
          .then(async response => {
            this.contact = response.data
          })
        if (this.contact.stripeCustomerId) {
          await this.fetchPaymentMethods()
        }
      }
    },
    async fetchPaymentMethods() {
      try {
        const params: object = {
          stripeCustomerId: this.contact.stripeCustomerId,
          offerId: this.offer.id
        }
        console.log(params)
        const {
          data
        } = await http.get(
          `/locations/${this.offer.locationId}/stripe/payment-methods`,
          { params }
        )
        this.paymentMethods = data
        console.log(this.paymentMethods)
      } catch (error) {
        console.error(error)
      }
    },
    async fetchUpsell() {
      try {
        this.loading = true
        const { data } = await CheckoutService.findByUpsellId(this.upsellId)
        this.upsellOffer = data.upsellOffer
        this.styles = this.upsellOffer.settings?.styles || null
        this.fontsToLoad = this.upsellOffer.settings?.fontsToLoad || null
        this.offer = new Offer(this.upsellOffer?.offerUpSell)
        this.products = data.products
        this.location = data.location
        this.upsellSettings = this.upsellOffer?.settings?.upsellSettings
        this.selectedTheme =
          this.upsellOffer.upsellType === UpsellOfferType.ONECLICK
            ? 'Classic'
            : 'Nova'
        if (!this.upsellOffer.active && !this.builder && !this.preview) {
          this.$router.push({ path: '/404' })
        }
      } catch (error) {
        console.log('Going Inside Catch')
        console.error(error)
      } finally {
        this.loading = false
      }
    },
    async checkout() {
      this.disableCheckoutBtn = true
      await this.checkContactPurchasedOffer()
      if (
        !this.optin &&
        !this.showThankYouMsg &&
        !this.freeProduct &&
        !this.offerAlreadyPurchased
      ) {
        this.showModal = true
      }
      this.disableCheckoutBtn = false
    },
    async checkContactPurchasedOffer() {
      if (
        !this.contact.id &&
        this.upsellOffer.upsellType === UpsellOfferType.INAPP
      ) {
        await this.fetchContact()
      }
      const {
        data: { purchased, loginUrl }
      } = await CheckoutService.checkIfContactPurchasedOffer({
        contactId: this.contact.id,
        offerId: this.offer.id,
        locationId: this.offer.locationId
      })
      this.offerAlreadyPurchased = purchased
      if (this.offerAlreadyPurchased) {
        this.url = loginUrl
        return
      }
      await this.createLeadEntry()
      if (this.offer.type === OfferType.free) {
        await this.createFreePurchase()
      }
      this.disableSubmitBtn = false
      this.optin = false
    },
    goToPreview() {
      if (this.cToken) {
        if (location.hostname === 'localhost') {
          window.open(
            `http://localhost:4040/${this.libraryPath}/?domain=${this.url}&token=${this.cToken}&location_id=${this.contact.location_id}`
          )
        } else {
          window.open(
            `${this.url}/${this.libraryPath}?&token=${this.cToken}&location_id=${this.contact.location_id}`
          )
        }
      }
    },
    async createFreePurchase() {
      const payload = {
        fingerprint: this.contact.fingerprint,
        locationId: this.contact.location_id,
        productType: 'offer',
        checkoutType: 'free',
        checkoutSource: this.checkoutSourceType
      }

      await CheckoutService.checkout(this.offer.id, payload)
        .then(response => {
          this.showThankYouMsg = true
          const { ct, previewUrl, featureFlag } = response.data
          this.cToken = ct
          this.url = previewUrl
          this.featureFlag = featureFlag
          this.showModal = true
          if (this.upsellOffer.upsellType === UpsellOfferType.INAPP) {
            setTimeout(() => {
              window.close()
            }, 2000)
          }
        })
        .catch(error => {
          console.error(error)
          const errorMessage = error?.response?.data?.msg
          this.errMsg =
            errorMessage || 'Something went wrong, please try again!'
        })
    },
    async createLeadEntry() {
      const payload = {
        contactId: this.contact.id,
        locationId: this.contact.location_id,
        offerId: this.$route.params.id
      }
      await CheckoutService.leadTrack(payload)
    }
  }
})
